import { Component, OnInit } from '@angular/core';
import { keyValueModal, bannerModal } from 'src/app/common/model';
import { HelperService } from 'src/app/services';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
navigationLinks : Array<bannerModal>;
  constructor(private _helper:HelperService) { }

  ngOnInit() {
	  this.getBreadcrumb();
  }
getBreadcrumb(){
    this.navigationLinks = new Array<bannerModal>();
    this._helper.getBreadcrumbs("Home|Register",this.navigationLinks);
  }
}
